import React, { useEffect, useState } from 'react';
import { B } from '../constants';

const LINE_MS = 2600;

export const craftingLines = ({ city, days, pace, budget }) => [
  `Asking locals where the real ${city} food is…`,
  `Squeezing ${days} days of sightseeing into your ${budget} budget…`,
  `Making sure you're not doing every museum on day 1…`,
  `Packing sunscreen, charger, passport ✓`,
  `Keeping it ${String(pace).toLowerCase()}: naps are allowed…`,
  `Finding photo spots your friends will be jealous of…`,
  `Plotting the shortest walk between coffee stops…`,
];

const CSS = `
.tcl { text-align: center; padding: 56px 20px 80px; }
.tcl-scene { width: 200px; height: 200px; margin: 0 auto 18px; display: block; }
.tcl-orbit { transform-origin: 100px 100px; animation: tclOrbit 4.2s linear infinite; }
.tcl-pin { transform-origin: 100px 112px; animation: tclBob 1.6s ease-in-out infinite; }
@keyframes tclOrbit { to { transform: rotate(360deg); } }
@keyframes tclBob { 50% { transform: translateY(-4px); } }
.tcl-line { min-height: 44px; max-width: 420px; margin: 18px auto 0; font-size: 15px; font-weight: 600; color: ${B.forest}; animation: tclIn .45s ease; }
@keyframes tclIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }
@media (prefers-reduced-motion: reduce) { .tcl-orbit, .tcl-pin, .tcl-line { animation: none; } }
`;

export default function TripCraftingLoader({ city, days, pace, budget }) {
  const lines = craftingLines({ city, days, pace, budget });
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI(n => (n + 1) % lines.length), LINE_MS);
    return () => clearInterval(t);
  }, [lines.length]);

  return (
    <div className="tcl">
      <style>{CSS}</style>
      <svg className="tcl-scene" viewBox="0 0 200 200" aria-hidden="true">
        <circle cx="100" cy="100" r="78" fill="#fff" fillOpacity="0.7" />
        <circle cx="100" cy="100" r="66" fill="none" stroke={B.forest} strokeOpacity="0.35" strokeWidth="2" strokeDasharray="2 7" strokeLinecap="round" />
        <g className="tcl-pin">
          <path d="M100 70c-13 0-22 9.5-22 21.5C78 107 100 128 100 128s22-21 22-36.5C122 79.5 113 70 100 70z" fill={B.forest} />
          <circle cx="100" cy="91" r="8" fill="#fff" />
        </g>
        <ellipse cx="100" cy="134" rx="14" ry="3.5" fill={B.night} fillOpacity="0.12" />
        <g className="tcl-orbit">
          <g transform="translate(100 34) rotate(90)">
            <path d="M0-13 L3 -3 L13 2 L13 5 L3 3 L2 10 L6 13 L6 15 L0 13.5 L-6 15 L-6 13 L-2 10 L-3 3 L-13 5 L-13 2 L-3 -3 Z"
              fill="#fff" stroke={B.night} strokeWidth="1.6" strokeLinejoin="round" />
          </g>
        </g>
      </svg>
      <div style={{ fontSize: 13, fontWeight: 800, letterSpacing: '.12em', color: B.muted, textTransform: 'uppercase' }}>{city}</div>
      <h2 className="serif" style={{ fontSize: 26, marginTop: 10 }}>Crafting your {days}-day {city} trip…</h2>
      <p style={{ color: B.muted, marginTop: 8 }}>Planning a {pace} itinerary to your {budget} style</p>
      <p key={i} className="tcl-line" role="status" aria-live="polite">{lines[i]}</p>
    </div>
  );
}
